import * as React from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

// Assets
import gidrLogo from "../../assets/gidr-logo.svg";

export default function SuccessReset() {
  return (
    <Container maxWidth="sm">
      <Paper sx={{ boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px" }}>
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 4,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} sx={{ mb: 1 }}>
              <img src={gidrLogo} alt="GIDR Logo" />
            </Grid>
            <Grid item xs={12} md={12} sx={{ mb: 1 }}>
              <Typography variant="h3" align="left">
                Successful Password Reset!
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <Typography variant="body2" align="left">
                You can now use your new password to login to your account 🙌🏻
              </Typography>
            </Grid>
          </Grid>
          <Button
            fullWidth
            component={Link}
            to="/login"
            variant="contained"
            sx={{ mt: 3, color: "#ffffff", boxShadow: "none" }}
          >
            Back to Login
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
